import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

const TEST_ID = 'eye-off-filled-icon';

/**
 * An Icon whose SVG shows an open eye without a line through it
 * @param IconProps
 */
export const EyeClosedIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 -5 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            data-testid={TEST_ID}
        >
            <g className={fillStyles}>
                <path d="M8.844 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.844 0C7.982 0 5.65 1.265 3.921 2.707 2.195 4.148 1.01 5.814.418 6.753l-.024.038c-.117.185-.27.425-.347.762a2.159 2.159 0 0 0 0 .894c.077.337.23.577.347.762l.024.038c.593.939 1.777 2.605 3.503 4.046C5.649 14.735 7.982 16 10.844 16s5.195-1.265 6.923-2.707c1.727-1.441 2.91-3.107 3.503-4.046l.024-.038c.118-.185.27-.425.348-.762a2.16 2.16 0 0 0 0-.894c-.078-.337-.23-.577-.348-.762l-.024-.038c-.593-.939-1.776-2.605-3.503-4.046C16.04 1.265 13.706 0 10.844 0Zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
                />
            </g>
        </svg>
    );
};

EyeClosedIcon.TEST_ID = TEST_ID;
